export default __webpack_public_path__ + "static/media/s2-img.196be414.png";